import React, { useEffect, useState } from "react";
import DataTable from "../../../components/Common/DataTable/DataTable";
import { useFetchData } from "../../../hooks/useFetchData";
import { getDistributionHistoryActionHandler } from "../../../store/actions/actionHandlers/distributeActionHandler";
import { distributionHistory } from "../../../utils/mainTabs/distribute/distributionHistory";
import DistributionHistoryInfo from "./DistributionHistoryInfo/DistributionHistoryInfo";

const DistributionHistory = () => {
  const [tableColumns, setTableColumns] = useState([]);
  const { columns } = distributionHistory;
  const pageSize = 13;
  const {
    data,
    setData,
    updatedData,
    totalRows,
    loading,
    handleSearchQuery,
    setUpdatedData,
    handleCurrentPage,
  } = useFetchData(getDistributionHistoryActionHandler, pageSize);
  const [viewModal, setviewModal] = useState(false);
  const [distributionHistoryInfo, setdistributionHistoryInfo] = useState([]);

  const handleViewModal = (row) => {
    setviewModal(true);
    setdistributionHistoryInfo(row);
  };

  useEffect(() => {
    let newTableColumns = columns(handleViewModal, setviewModal);
    setTableColumns(newTableColumns);
  }, [columns]);

  return (
    <>
      <DataTable
        columns={tableColumns}
        defaultData={data}
        setDefaultData={setData}
        data={updatedData}
        setData={setUpdatedData}
        totalRows={totalRows}
        loading={loading}
        uniqueFieldName={"Id"}
        setSearchQuery={handleSearchQuery}
        fetchMoreData={handleCurrentPage}
      />
      {viewModal && (
        <DistributionHistoryInfo
          info={distributionHistoryInfo}
          isViewModal={viewModal}
          setisViewModal={setviewModal}
        />
      )}
    </>
  );
};

export default DistributionHistory;
